import { render, staticRenderFns } from "./VuesticAccordion.vue?vue&type=template&id=458f2b8a"
import script from "./VuesticAccordion.vue?vue&type=script&lang=js"
export * from "./VuesticAccordion.vue?vue&type=script&lang=js"
import style0 from "./VuesticAccordion.vue?vue&type=style&index=0&id=458f2b8a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('458f2b8a')) {
      api.createRecord('458f2b8a', component.options)
    } else {
      api.reload('458f2b8a', component.options)
    }
    module.hot.accept("./VuesticAccordion.vue?vue&type=template&id=458f2b8a", function () {
      api.rerender('458f2b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-collapse/VuesticAccordion.vue"
export default component.exports